
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/shop-dine-and-relax",
      function () {
        return require("private-next-pages/[locale]/shop-dine-and-relax/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/shop-dine-and-relax"])
      });
    }
  